module.exports = __webpack_public_path__ + "media/projects-cropped.d094b090.mp4";